import { useRouteDetermination } from './useRouteDetermination';

export default function useLandingRoute(): string {
  const route = useRouteDetermination();
  if (!route) {
    return '/tailor';
  }
  return route;
}
